import {
    CheckCircleOutlined,
    EditOutlined,
    StopOutlined,
  } from "@ant-design/icons";
  import { PageHeader, Popconfirm, message, Tooltip } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";

  class Servicios extends Component {
    state = {
      idEditarServicio: null,
      modalAgregarFamilia: false,
      todasServicios: [],
      loading: false,
      valor: 1,
    };
    componentDidMount() {
      this.consultarServicios(this.state.valor);
    }
    consultarServicios(valor) {
      this.setState({loading: true})
      axios
        .post(
          "servicios/selectTodosServicios",
          { empresaId: this.props.empresaId, valor: valor },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({loading: false})
          if (res.data.status === 404) {
            this.setState({ todasServicios: [] });
          } else {
            this.setState({
              todasServicios: res.data
            });
          }
        });
    }
    deshabilitarServicio(value) {
      axios
        .post(
          "insumos/deshabilitarInsumo",
          { insumoId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Servicio deshabilitado");
          } else {
            message.error("Sucedio un eror y no se pudo deshabilitar");
          }
          this.consultarServicios(this.state.valor);
        });
    }
    habilitarServicio(value) {
      axios
        .post(
          "insumos/habilitarInsumo",
          { insumoId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Servicio habilitado");
          } else {
            message.error("Sucedio un eror y no se pudo habilitar");
          }
          this.consultarServicios(this.state.valor);
        });
    }
    agregarServicio() {
      this.props.history.push("/panel/agregarServicio");
    }
    editarServicio(id) {
      this.props.history.push("/panel/editarServicio", { id });
    }
    abrirAgregarFamilia() {
      this.setState({ modalAgregarFamilia: true });
    }
    cerrarAgregarFamilia() {
      this.setState({ modalAgregarFamilia: false });
      this.consultarServicios(this.state.valor);
    }
    render() {
      const columns = [
        /*{
          title: "Codigo",
          dataIndex: "codigo",
          key: "codigo",
          defaultSortOrder: 'ascend',
          sorter: (a, b) => {
            if (a.codigo < b.codigo) {
              return -1;
            }
            if (a.codigo > b.codigo) {
              return 1;
            }
            return 0;
          },
          buscar: "codigo",
          width: "10%",
        },*/
        {
          title: "Clave",
          dataIndex: "clave",
          key: "clave",
          sorter: (a, b) => {
            if (Number(a.clave) < Number(b.clave)) {
              return -1;
            }
            if (Number(a.clave) > Number(b.clave)) {
              return 1;
            }
            return 0;
          },
          buscar: "clave",
          width: "10%",
        },
        {
          title: "Descripción",
          dataIndex: "descripcion",
          key: "descripcion",
          sorter: (a, b) => {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          },
          buscar: "descripcion",
          width: "36%",
        },
        {
          title: "Costo",
          dataIndex: "costo",
          key: "costo",
          sorter: (a, b) => {
            if (a.costo < b.costo) {
              return -1;
            }
            if (a.costo > b.costo) {
              return 1;
            }
            return 0;
          },
          render: (value) => "$ " + value.toFixed(2),
          width: "8%",
        },
        {
          title: "Unidad",
          dataIndex: "unidad",
          key: "unidad",
          sorter: (a, b) => {
            if (a.unidad < b.unidad) {
              return -1;
            }
            if (a.unidad > b.unidad) {
              return 1;
            }
            return 0;
          },
          width: "12%",
        },
        {
          title: "Familia",
          dataIndex: "familia",
          key: "familia",
          sorter: (a, b) => {
            if (a.familia < b.familia) {
              return -1;
            }
            if (a.familia > b.familia) {
              return 1;
            }
            return 0;
          },
          width: "10%",
        },
        {
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: "12%",
          onHeaderCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          onCell: () => ({
            className: "acciones-sin-hover",
            style: { textAlign: 'center', padding: '4px' }
          }),
          render: (value, index) => {
            let buttons = [];

            // Botón Editar
            if (this.props.permisoEditarServicio) {
              buttons.push(
                <Tooltip title="Editar Servicio" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`editar-${index}`}
                    type="default"
                    size="small"
                    cyan
                    icon={<EditOutlined />}
                    onClick={() => this.editarServicio(value._id)}
                  >
                  </ButtonItem>
                </Tooltip>
              );
            }

            // Botón Habilitar/Deshabilitar
            if (this.props.permisoDeshabilitarServicio) {
              if (value.estado === 1) {
                buttons.push(
                  <Popconfirm
                    key={`deshabilitar-${index}`}
                    title="Seguro que quieres deshabilitar este servicio"
                    onConfirm={() => this.deshabilitarServicio(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        lima
                        icon={<CheckCircleOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              } else {
                buttons.push(
                  <Popconfirm
                    key={`habilitar-${index}`}
                    title="Seguro que quieres habilitar este servicio"
                    onConfirm={() => this.habilitarServicio(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        rojo
                        icon={<StopOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              }
            }

            return <div className="acciones-container">{buttons}</div>;
          },
        },
      ];
      return (
        <>
          <PageHeader
            title="Servicios"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <>
              {window.innerWidth > 1000 &&
              <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarServicios(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
            }
              {this.props.permisoAgregarServicio ?
              <ButtonItem
                type="primary"
                key="agregarServicio"
                olivo
                onClick={this.agregarServicio.bind(this)}
                 className="botonAgregar"
              >
                Agregar Servicio
              </ButtonItem>
            : null}
            </>}
          />
          <TableItem
          loading={this.state.loading}
            size="small"
            dataSource={this.state.todasServicios}
            columns={columns}
            pagination={false}
            onRow={(record) => ({
              onDoubleClick: () => this.editarServicio(record._id),
            })}
          />
        </>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      permisoAgregarServicio: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d5754b2da7c85c1a8d02")?.activado,
      permisoEditarServicio: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d5a84b2da7c85c1a8d03")?.activado,
      permisoDeshabilitarServicio: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d5de4b2da7c85c1a8d04")?.activado,
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };

  export default connect(mapStateToProps)(Servicios);
